import React from 'react';
export const WhatIsIncluded: React.FC = () => {
  const items = [{
    num: 1,
    title: '50 Sesiones de Entrenamiento — Listas para Usar',
    desc: 'Sesiones completas que copiás directo a tu planificación. Fuerza, resistencia, velocidad, técnica.',
    colors: 'bg-blue-50 border-blue-200 text-blue-900',
    numColor: 'text-blue-600'
  }, {
    num: 2,
    title: 'El Sistema del Entrenador Inteligente',
    desc: 'El método completo para diseñar entrenamientos que realmente progresan.',
    colors: 'bg-green-50 border-green-200 text-green-900',
    numColor: 'text-green-600'
  }, {
    num: 3,
    title: 'Planes de Partido y Tácticas Reales',
    desc: 'Esquemas tácticos, formaciones, estrategias específicas por momento del partido.',
    colors: 'bg-orange-50 border-orange-200 text-orange-900',
    numColor: 'text-orange-600'
  }, {
    num: 4,
    title: 'Errores y Ejercicios que Arruinan tus Entrenamientos',
    desc: 'Los 20 errores más comunes + ejercicios correctivos para cada uno.',
    colors: 'bg-purple-50 border-purple-200 text-purple-900',
    numColor: 'text-purple-600'
  }, {
    num: 5,
    title: 'Plan Semanal del Entrenador',
    desc: 'Plantillas semanales completas con distribución de cargas, descansos, énfasis por día.',
    colors: 'bg-red-50 border-red-200 text-red-900',
    numColor: 'text-red-600'
  }, {
    num: 6,
    title: 'Guía para Armar tus Propios Entrenamientos',
    desc: 'El paso a paso completo: cómo elegir ejercicios, cómo ordenarlos, cómo progresar.',
    colors: 'bg-teal-50 border-teal-200 text-teal-900',
    numColor: 'text-teal-600'
  }];
  return <section className="py-14 px-4 bg-gray-50" data-id="element-313">
      <div className="max-w-4xl mx-auto" data-id="element-314">
        <h2 className="text-3xl md:text-4xl font-bold text-center text-gray-900 mb-10" data-id="element-315">
          ¿Qué incluye exactamente el Megapack?
        </h2>

        <div className="space-y-4" data-id="element-316">
          {items.map(item => <div key={item.num} className={`p-5 md:p-6 rounded-2xl border-2 ${item.colors} shadow-sm transition-transform hover:-translate-y-1`} data-id="element-317">
              <div className="flex flex-col md:flex-row gap-4 items-start md:items-center" data-id="element-318">
                <div className="flex-shrink-0 w-12 h-12 bg-white/60 rounded-full flex items-center justify-center shadow-sm" data-id="element-319">
                  <span className={`text-xl font-black ${item.numColor}`} data-id="element-320">
                    {item.num}
                  </span>
                </div>
                <div data-id="element-321">
                  <h3 className="text-lg md:text-xl font-bold mb-1" data-id="element-322">
                    {item.title}
                  </h3>
                  <p className="text-gray-700 text-base" data-id="element-323">{item.desc}</p>
                </div>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
};